import React from 'react'
import { LABELS } from '../constants/staticText'
import useLoad from '../functions/useLoad'
import { loadMembers } from '../apis/publicApi'
import { fileUrl } from '../functions/fileUrl'
import { bildMasse } from '../../lib/functions/bildMasse'
import LoadingIndicator from '../../lib/components/LoadingIndicator'
import { exhibitorProfilePath } from '../../lib/functions/exhibitorProfilePath'

// Logo-Raster der Mitgliederseite (#242), Shortcode [job4u_mitglieder]: je
// Vereinsmitglied eine Karte mit Logo — Aufbau und Masse wie das bisherige
// Elementor-Raster (.logos-grid). Anders als dort traegt jedes Logo den
// Firmennamen als Alternativtext: es ist der einzige Inhalt der Karte.
// Mit oeffentlichem Profil fuehrt das Logo auf die Aussteller-Seite (#249);
// ohne bleibt es ein Bild. Der innere Rahmen traegt die Hover-Animation wie
// .elementor-widget-container im Original.
const Logo = ({ member }) => {
    const bild = (
        <img
            src={fileUrl(member.logo.fileId)} alt={member.name}
            loading="lazy" decoding="async" {...bildMasse(member.logo)}
        />
    )

    return member.profile
        ? <a className="job4u-members-logo" href={exhibitorProfilePath(member.id)}>{bild}</a>
        : <span className="job4u-members-logo">{bild}</span>
}

const MembersGrid = () => {
    const { data, loading, error } = useLoad(loadMembers, [])

    if (loading) return <LoadingIndicator label={LABELS.loadingMembers} />
    if (error) return <p className="events-state" role="status">{LABELS.error}</p>

    return (
        <ul className="job4u-members-grid">
            {data.map(member => (
                <li key={member.id} className="job4u-members-card">
                    <Logo member={member} />
                </li>
            ))}
        </ul>
    )
}

export default MembersGrid
